import en from './en';
import es from './es';

const resources = {
  en: en,
  es: es,
};

export default resources;
